import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { TourId } from '../../../View/HelpTour/tourMeta.js'

export interface ITourState {
  isTourActive: boolean,
  currentStep: number,
  completedSteps: number[],
  userDismissed: boolean,
  originPath?: string,
  activeTour?: TourId,
}

const initialState: ITourState = {
  isTourActive: false,
  currentStep: 0,
  completedSteps: [],
  userDismissed: false,
}

export const tourSlice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    startTour: (state, action: PayloadAction<TourId>) => {
      state.isTourActive = true
      state.currentStep = 0
      state.userDismissed = false
      state.originPath = window.location.pathname
      state.completedSteps = []
      state.activeTour = action.payload
    },
    reset: () => {
      return initialState
    },
    setIsTourActive: (state, action: PayloadAction<boolean>) => {
      state.isTourActive = action.payload
    },
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload
    },
    addCompletedStep: (state, action: PayloadAction<number>) => {
      if (!state.completedSteps.includes(action.payload)) {
        state.completedSteps.push(action.payload)
      }
    },
    setCompletedSteps: (state, action: PayloadAction<number[]>) => {
      state.completedSteps = action.payload
    },
    setUserDismissed: (state, action: PayloadAction<boolean>) => {
      state.userDismissed = action.payload
    },
    setOriginPath: (state, action: PayloadAction<string>) => {
      state.originPath = action.payload
    },
  }
})

export const {
  reset,
  setIsTourActive,
  setCurrentStep,
  addCompletedStep,
  setCompletedSteps,
  setUserDismissed,
  setOriginPath
} = tourSlice.actions

// Selectors
export const selectIsTourActive = (state: { tour: ITourState }) => state.tour.isTourActive
export const selectCurrentStep = (state: { tour: ITourState }) => state.tour.currentStep
export const selectCompletedSteps = (state: { tour: ITourState }) => state.tour.completedSteps
export const selectUserDismissed = (state: { tour: ITourState }) => state.tour.userDismissed
export const selectOriginPath = (state: { tour: ITourState }) => state.tour.originPath
export const currentTour = (state: { tour: ITourState}) => state.tour.activeTour

export default tourSlice.reducer
